// extracted by mini-css-extract-plugin
export default {"DayOfWeek":"dayOfWeek_DayOfWeek__Ns7WA","box":"dayOfWeek_box__IQ7VW","name":"dayOfWeek_name__uJYN+","saturday":"dayOfWeek_saturday__UoJN3","sunday":"dayOfWeek_sunday__H7G4P"};